var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLikeEmpty({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.6263 2.76153C18.591 1.62561 17.1704 1 15.6259 1C14.4714 1 13.4141 1.36922 12.4833 2.09733C12.0137 2.46486 11.5881 2.9145 11.2129 3.43932C10.8378 2.91466 10.4121 2.46486 9.94229 2.09733C9.01166 1.36922 7.95438 1 6.7999 1C5.2554 1 3.83466 1.62561 2.79935 2.76153C1.7764 3.88418 1.21289 5.41788 1.21289 7.08032C1.21289 8.79138 1.84323 10.3576 3.19653 12.0096C4.40717 13.4873 6.14713 14.9873 8.16205 16.7243C8.85007 17.3175 9.62994 17.9899 10.4397 18.7061C10.6537 18.8957 10.9282 19 11.2129 19C11.4975 19 11.7721 18.8957 11.9857 18.7064C12.7955 17.99 13.5759 17.3173 14.2642 16.7238C16.2788 14.9872 18.0188 13.4873 19.2294 12.0094C20.5827 10.3576 21.2129 8.79138 21.2129 7.08016C21.2129 5.41788 20.6494 3.88418 19.6263 2.76153Z",
    stroke: "#DE010E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLikeEmpty);
export default __webpack_public_path__ + "static/media/like-empty.2d2de23172fab6835a576adfc235acc3.svg";
export { ForwardRef as ReactComponent };